import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Container, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold",
        marginBottom:"1rem"
    },
}));

export const DiscapacidadAfi = (props) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Container maxWidth="sm">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>Discapacidad</Typography>
                <Typography align="center">Gestioná las solicitudes y el seguimiento de las mismas.</Typography>
                
                <Button component={Link} to="/afiliado/discapacidad/nueva-solicitud" fullWidth variant="outlined" color="primary" style={{marginTop:"1rem", textTransform:"none"}}>Nueva Solicitud</Button>
                <Button component={Link} to="/afiliado/discapacidad/mis-solicitudes" fullWidth variant="outlined" color="primary" style={{marginTop:"1rem", textTransform:"none"}}>Mis Solicitudes</Button>

            </Container>
        </div>
    );
};
